import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-e-liggare',
  templateUrl: './e-liggare.component.html',
})
export class FeaturePreviewEliggare extends FeaturePreviewComponent {}
